import Vue from 'vue'
import cookie from 'js-cookie';

window.NProgress = require('nprogress');
require('nprogress/nprogress.css');

import Router from 'vue-router';
import BHeader from '../components/BHeader'
import BFooter from '../components/BFooter'

// 主页
const Index_Index = ()=>import( '../components/Index/index');
const Build_Index = ()=>import('../components/Build/index');

// 后台
const Dashboard = ()=>import('../components/Dashboard/dashboard');
const Main_List = ()=>import('../components/Dashboard/main/main_list');
const Code_List = ()=>import('../components/Dashboard/code/code_list');
const Server_List = ()=>import('../components/Dashboard/server/server_list');
const Server_Add = ()=>import('../components/Dashboard/server/server_add');
const Server_Edit = ()=>import('../components/Dashboard/server/server_edit');
const Markdown_List = ()=>import('../components/Dashboard/markdown/markdown_list');
const Person_Main = ()=>import("../components/Dashboard/person/main");

// 登录注册
const Account_Login = ()=>import('../components/Account/login');
const Account_Logout = ()=>import('../components/Account/logout');
const Account_Register = ()=>import('../components/Account/register');
const Account_Forgot = ()=>import('../components/Account/forgot');
const SocialGithubLogin = ()=>import('../components/Account/social_github_login');
const Social_Github_Register = ()=>import('../components/Account/social_github_register');
const SocialGitlabLogin = ()=>import('../components/Account/social_gitlab_login');
const SocialGitlabRegister = ()=>import('../components/Account/social_github_register');

// 前端工具
const Frontend_Html = ()=>import('../components/Frontend/html_format');
const Frontend_Encode = ()=>import('../components/Frontend/js_encode');
const Frontend_Transfer = ()=>import('../components/Frontend/js_transfer');
const Frontend_Typescript = ()=>import('../components/Frontend/js_compiler');
const Frontend_Less = ()=>import('../components/Frontend/js_less');

// 工具类
const Tools_Markdown = ()=>import('../components/Tools/markdown-component');
const Tools_Json = ()=>import('../components/Tools/json_format');
const Tools_Crypto = ()=>import('../components/Tools/crypto');
const Tools_QrcodeScan = ()=>import('../components/Tools/qrcode_scan');

// 在线ssh
const Online_Ssh = ()=>import('../components/Online/ssh');

// 404
const NotFound = ()=>import("../components/Util/not_found");
const ContactUs = ()=>import("../components/Util/contact_us");
const AboutUs = ()=>import("../components/Util/about_us");
const Feedback = ()=>import("../components/Util/feedback");

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject){
	if(onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch(err=>err)
};

Vue.use(Router);

let router = new Router({
	linkActiveClass: 'active',
	mode: 'history',
	routes: [
		{
			//首页
			path: '/',
			name: 'Index_index',
			meta: {title: "首页"},
			components: {
				'bl-header': BHeader,
				'bl-content': Index_Index,
				'bl-footer': BFooter
			}
		},
		{
			//代码在线运行
			path: '/build/:lang/editor',
			name: 'Build',
			meta: {title: "代码在线运行"},
			components: {
				'bl-header': BHeader,
				'bl-content': Build_Index,
			},
		},
		{
			//代码在线运行
			path: '/build/:lang/editor/:hash',
			name: 'BuildView',
			meta: {title: "代码在线运行"},
			components: {
				'bl-header': BHeader,
				'bl-content': Build_Index,
			},
		},
		{
			//ssh在线运行
			path: '/online/ssh',
			name: 'OnlineSsh',
			meta: {title: "SSH在线运行"},
			components: {
				'bl-header': BHeader,
				'bl-content': Online_Ssh,
			},
		},
		{
			//前端代码格式化
			path: '/frontend/html',
			name: 'ToolHtml',
			meta: {title: "前端代码格式化"},
			components: {
				'bl-header': BHeader,
				'bl-content': Frontend_Html,
				'bl-footer': BFooter
			},
		},
		{
			//js混淆加密，解密
			path: '/frontend/encode',
			name: 'ToolEncode',
			meta: {title: "JS混淆加密、解密"},
			components: {
				'bl-header': BHeader,
				'bl-content': Frontend_Encode,
				'bl-footer': BFooter
			},
		},
		{
			//js5-6转译
			path: '/frontend/transfer',
			name: 'ToolTransfer',
			meta: {title: "ES5-ES6转译"},
			components: {
				'bl-header': BHeader,
				'bl-content': Frontend_Transfer,
				'bl-footer': BFooter
			},
		},
		{
			//less css转译
			path: '/frontend/less',
			meta: {title: "LESS-SASS转译"},
			name: 'ToolLess',
			components: {
				'bl-header': BHeader,
				'bl-content': Frontend_Less,
				'bl-footer': BFooter
			},
		},
		{
			//typescript
			path: '/frontend/typescript',
			meta: {title: "TypeScript转译"},
			name: 'ToolTs',
			components: {
				'bl-header': BHeader,
				'bl-content': Frontend_Typescript,
				'bl-footer': BFooter
			},
		},
		{
			path: '/tools/json',
			name: 'ToolJson',
			meta: {title: "JSON在线格式化"},
			components: {
				'bl-header': BHeader,
				'bl-content': Tools_Json,
				'bl-footer': BFooter
			},
		},
		{
			path: '/tools/crypto',
			name: 'ToolCrypto',
			meta: {title: "RSA、DES在线加解密"},
			components: {
				'bl-header': BHeader,
				'bl-content': Tools_Crypto,
				'bl-footer': BFooter
			},
		},
		{
			path: '/tools/markdown',
			name: 'ToolMarkdown',
			meta: {title: "在线Markdown"},
			components: {
				'bl-header': BHeader,
				'bl-content': Tools_Markdown,
				'bl-footer': BFooter
			},
		},
		{
			path: '/tools/markdown/edit/:hash',
			name: 'ToolMarkdownEdit',
			meta: {title: "在线Markdown"},
			components: {
				'bl-header': BHeader,
				'bl-content': Tools_Markdown,
				'bl-footer': BFooter
			},
		},
		{
			path: '/tools/qrcode',
			name: 'ToolQrcode',
			meta: {title: "二维码在线识别"},
			components: {
				'bl-header': BHeader,
				'bl-content': Tools_QrcodeScan,
				'bl-footer': BFooter,
			}
		},
		{
			//登录
			path: '/login',
			name: 'Login',
			meta: {title: "用户登录"},
			components: {
				'bl-header': BHeader,
				'bl-content': Account_Login,
				'bl-footer': BFooter
			}
		},
		{
			//登录
			path: '/forgot',
			name: 'Forgot',
			meta: {title: "找回密码"},
			components: {
				'bl-header': BHeader,
				'bl-content': Account_Forgot,
				'bl-footer': BFooter
			}
		},
		{
			//社会化登录
			path: '/social/github/login',
			name: 'SocialGithubLogin',
			meta: {title: "社会化登录"},
			components: {
				'bl-header': BHeader,
				'bl-content': SocialGithubLogin,
				'bl-footer': BFooter
			}
		},
		{
			//社会化登录注册
			path: '/social/github/register',
			name: 'SocialGithubRegister',
			meta: {title: "社会化注册"},
			components: {
				'bl-header': BHeader,
				'bl-content': Social_Github_Register,
				'bl-footer': BFooter
			}
		},
		{
			//社会化登录
			path: '/social/gitlab/login',
			name: 'SocialGitlabLogin',
			meta: {title: "社会化登录"},
			components: {
				'bl-header': BHeader,
				'bl-content': SocialGitlabLogin,
				'bl-footer': BFooter
			}
		},
		{
			//社会化登录注册
			path: '/social/gitlab/register',
			name: 'SocialGitlabRegister',
			meta: {title: "社会化注册"},
			components: {
				'bl-header': BHeader,
				'bl-content': SocialGitlabRegister,
				'bl-footer': BFooter
			}
		},
		{
			//注册
			path: '/register',
			name: 'Register',
			meta: {title: "用户注册"},
			components: {
				'bl-header': BHeader,
				'bl-content': Account_Register,
				'bl-footer': BFooter
			}
		},
		{
			//注销
			path: '/logout',
			name: 'Logout',
			meta: {title: "用户注销"},
			components: {
				'bl-header': BHeader,
				'bl-content': Account_Logout,
				'bl-footer': BFooter
			}
		},
		{
			//管理后台
			path: '/dashboard',
			components: {
				'bl-header': BHeader,
				'bl-content': Dashboard,
				'bl-footer': BFooter
			},
			children: [
				{
					path: '/',
					meta: {title: "代码片段管理"},
					redirect: "/dashboard/code",
				},
				{
					path: 'main',
					name: 'DashboardMain',
					meta: {title: "管理主界面"},
					// component: Main_List
					redirect: "/dashboard/code",
				},
				{
					path: 'code',
					name: 'DashboardCode',
					meta: {title: "代码片段管理"},
					component: Code_List
				},
				{
					path: 'server',
					meta: {title: "服务器管理"},
					name: 'DashboardServer',
					component: Server_List
				},
				{
					path: 'server/add',
					meta: {title: "服务器添加"},
					name: 'DashboardServerAdd',
					component: Server_Add
				},
				{
					path: 'server/edit/:id',
					meta: {title: "服务器编辑"},
					name: 'DashboardServerEdit',
					component: Server_Edit
				},
				{
					path: 'markdown',
					meta: {title: "文档管理"},
					name: 'DashboardMarkdown',
					component: Markdown_List
				},
				{
					path: 'person',
					meta: {title: "个人信息管理"},
					name: 'DashboardPerson',
					component: Person_Main,
				}
			]
		},
		{
			path: "/contact-us",
			name: "ContactUs",
			meta: {title: "联系我们"},
			components: {
				'bl-header': BHeader,
				'bl-content': ContactUs,
				'bl-footer': BFooter
			}
		},
		{
			path: "/about-us",
			name: "AboutUs",
			meta: {title: "网站说明"},
			components: {
				'bl-header': BHeader,
				'bl-content': AboutUs,
				'bl-footer': BFooter
			}
		},
		{
			path: "/feedback",
			name: "Feedback",
			meta: {title: "反馈建议"},
			components: {
				'bl-header': BHeader,
				'bl-content': Feedback,
				'bl-footer': BFooter
			}
		},
		{
			path: '*',
			name: 'NotFound',
			meta: {title: "无法找到指定资源页面"},
			components: {
				'bl-header': BHeader,
				'bl-content': NotFound,
				'bl-footer': BFooter
			}
		}
	]
});

router.beforeEach((to, from, next)=>{
	// title更改
	NProgress.done().start();
	let title = "软件开发工具 | 程序员社区 - ByteLang字节社";
	if(to.meta.title){
		title = to.meta.title + " | " + title;
	}
	document.title = title;
	// 路由分发
	next();
});

router.afterEach(route=>{
	NProgress.done();

	// 处理用户登录态
	if(router.app.$store.state.user === null){
		router.app.$store.dispatch('GetUserFromCookie');
	}
});


export default router
